"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDataStruct = exports.FormFieldDataStruct = void 0;
const superstruct_1 = require("superstruct");
exports.FormFieldDataStruct = (0, superstruct_1.type)({
    fieldId: (0, superstruct_1.string)(),
    value: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    multiValue: (0, superstruct_1.optional)((0, superstruct_1.array)((0, superstruct_1.string)())),
    type: (0, superstruct_1.string)(),
    label: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    pageNumber: (0, superstruct_1.optional)((0, superstruct_1.number)()),
});
exports.FormDataStruct = (0, superstruct_1.type)({
    formId: (0, superstruct_1.string)(),
    data: (0, superstruct_1.array)(exports.FormFieldDataStruct),
});
exports.FormFieldDataStruct.type = 'FormFieldData';
exports.FormDataStruct.type = 'FormData';
//# sourceMappingURL=formData.js.map